import { Component, computed, inject, Input, ViewChild } from '@angular/core';
import { EHeaderProfileTypes } from '@app-root-enums';
import { SiHeaderDropdownTriggerDirective } from '@siemens/element-ng/header-dropdown';
import { IProfile } from '@scf-monorepo/interfaces';
import { AuthService } from '../../root-services/auth.service';

@Component({
    selector: 'app-header-profile',
    templateUrl: './header-profile.component.html',
    styleUrls: ['./header-profile.component.scss'],
    standalone: false
})
export class HeaderProfileComponent {
    @Input() profile: IProfile | null = null;
    @Input() mode: EHeaderProfileTypes = EHeaderProfileTypes.FULL;
    @ViewChild(SiHeaderDropdownTriggerDirective)
    dropdownTrigger!: SiHeaderDropdownTriggerDirective;

    private readonly authService = inject(AuthService);

    public profileTypes = EHeaderProfileTypes;
    public isDropdownOpen = false;
    public userPhotoUrl = computed(() => this.authService.getUserPhotoUrl());

    public closeDropdown(): void {
        this.dropdownTrigger?.close();
    }

    public openDropdown(): void {
        this.dropdownTrigger?.open();
    }
}
